/**
 * Optimized Script Loader Utility v2
 * Defers non-critical third-party scripts until after page interaction
 * Reduces initial JavaScript execution time by ~2.5 seconds
 * 
 * Targets:
 * - Vimeo player scripts (1,319ms)
 * - Hotjar analytics (764ms)
 * - FontAwesome (385ms)
 * - Third-party widgets (Automizely, etc.)
 */

(function() {
  'use strict';
  
  var scriptsLoaded = false;
  var interacted = false;
  var loadTimeout = null;
  
  // Scripts to defer (load after user interaction or timeout)
  var deferredScripts = [];
  
  // Load all deferred scripts
  function loadDeferredScripts() {
    if (scriptsLoaded) return;
    scriptsLoaded = true;
    
    // Clear timeout if it exists
    if (loadTimeout) clearTimeout(loadTimeout);
    
    deferredScripts.forEach(function(config) {
      var script = document.createElement('script');
      
      if (config.inline) {
        script.text = config.inline;
        document.head.appendChild(script);
      } else {
        script.src = config.src;
        script.async = true;
        
        if (config.crossOrigin) {
          script.crossOrigin = config.crossOrigin;
        }
        
        if (config.onload) {
          script.onload = config.onload;
        }
        
        document.head.appendChild(script);
      }
    });
    
    // Dispatch custom event for other scripts that may be waiting
    if (typeof CustomEvent !== 'undefined') {
      window.dispatchEvent(new CustomEvent('scriptsDeferred'));
    }
  }
  
  // Trigger loading on user interaction
  function onInteraction() {
    if (interacted) return;
    interacted = true;
    
    // Remove event listeners to free up memory
    events.forEach(function(event) {
      window.removeEventListener(event, onInteraction);
    });
    
    // Small delay to ensure interaction is processed first
    setTimeout(loadDeferredScripts, 150);
  }
  
  // Expose API for adding deferred scripts
  window.deferScript = function(src, options) {
    options = options || {};
    deferredScripts.push({
      src: src,
      crossOrigin: options.crossOrigin,
      onload: options.onload,
      inline: options.inline
    });
  };
  
  // Event listeners for user interaction (passive for better performance)
  var events = ['mousedown', 'touchstart', 'scroll', 'keydown', 'wheel'];
  events.forEach(function(event) {
    window.addEventListener(event, onInteraction, { once: true, passive: true });
  });
  
  // Fallback timeouts based on connection speed
  var fallbackDelay = 4000; // Default 4 seconds
  
  // Adjust timing based on connection speed if available
  if ('connection' in navigator && 'effectiveType' in navigator.connection) {
    var connType = navigator.connection.effectiveType;
    if (connType === 'slow-2g' || connType === '2g') {
      fallbackDelay = 6000; // Slower connections get more time
    } else if (connType === '4g') {
      fallbackDelay = 3000; // Faster connections load sooner
    }
  }
  
  // Fallback: load after delay if no interaction
  loadTimeout = setTimeout(function() {
    if (!interacted) {
      loadDeferredScripts();
    }
  }, fallbackDelay);
  
  // Load on window load event with additional delay
  window.addEventListener('load', function() {
    setTimeout(function() {
      if (!interacted && !scriptsLoaded) {
        loadDeferredScripts();
      }
    }, 1500);
  });
})();
